<div>
	<div class="input-wrapper">
		<div
			class="input {{ styleClass() }}"
			[class.input-focused]="focused()"
			[class.input-disabled]="disabled()"
			[class.!input-valid]="showSuccess()"
			[class.input-error]="showError()"
		>
			<input
				[type]="
					type() === 'password' && passwordVisible()
						? 'text'
						: type() === 'search'
							? 'text'
							: type()
				"
				class="input-field"
				[value]="value()"
				[disabled]="disabled()"
				[placeholder]="placeholder()"
				[attr.maxlength]="maxLength()"
				(input)="onInput($event)"
				(focusout)="onFocusOut()"
				(focusin)="onFocusIn()"
				[id]="inputId()"
				data-cy="ui-input-value"
				#inputElement
			/>
			<div class="flex items-center h-10">
				<ng-content select="[custom-icon]"></ng-content>

				@if (type() === 'search') {
					<!-- Search Icon when the input is a search input -->
					@if (!value()) {
						<ui-icon icon="lens_search" size="s"> </ui-icon>
					} @else {
						<ui-icon
							icon="x_cross"
							size="s"
							class="cursor-pointer"
							tabindex="0"
							(keydown.enter)="clearInput($event)"
							(mousedown)="clearInput($event)"
						></ui-icon>
					}
				} @else if (type() === 'password') {
					<ui-icon
						[icon]="passwordVisible() ? 'visibility_off' : 'visibility_on'"
						size="s"
						class="cursor-pointer"
						tabindex="0"
						(click)="toggleVisibility()"
						(keydown.enter)="toggleVisibility()"
					>
					</ui-icon>
				} @else {
					@if (showClearIcon()) {
						<ui-icon
							icon="x_cross"
							size="s"
							class="cursor-pointer"
							(mousedown)="clearInput($event)"
						></ui-icon>
					}

					@if (showError()) {
						<ui-icon icon="failures" type="error" size="s"> </ui-icon>
					}

					@if (showSuccess()) {
						<ui-icon icon="x_check" type="success" size="s"> </ui-icon>
					}
				}
			</div>
		</div>
	</div>
	@if (errorMessage()) {
		<span class="form-error" data-cy="ui-input-error">{{ errorMessage() }}</span>
	}
</div>
